module.exports = __webpack_public_path__ + "img/badge_exantemutua.619d3556.jpg";